<script setup lang="ts">
const { locale } = useI18n();
const { onLocaleChange } = useLocalization();

withDefaults(defineProps<{
  languages: CourseAvailableLanguage[];
  size?: string;
}>(),
{
  size: '26px',
});
</script>

<template>
  <Dropdown
    v-model="locale"
    :options="languages"
    option-value="isoCode"
    option-label="name"
    placeholder="Please select"
    scroll-height="250px"
    append-to="self"
    class="country-select w-full"
    :pt="{
      root: {
        class: `h-[${size}] flex items-center`
      },
      input: {
        class: `!h-[${size}] py-1 pl-2 pr-0`
      },
      trigger: {
        class: 'w-6 mr-2'
      },
      list: {
        class: 'p-0'
      },
      wrapper: {
        class: 'rounded-md'
      },
      item: {
        class: 'py-2'
      }
    }"
    @update:model-value="onLocaleChange"
  >
    <template #value="{value}">
      <div class="flex items-center">
        <MIcon
          sprite-location="/icons/country_flags.svg"
          :icon="languages?.find((lang) => lang.isoCode === value)?.countryCode?.toUpperCase() as string"
          class="rounded-sm mr-2 country-flag-icon--value"
        />
        <div>
          {{languages?.find((lang) => lang.isoCode === value)?.name}}
        </div>
      </div>
    </template>

    <template #option="{option}">
      <div class="flex items-center">
        <MIcon
          sprite-location="/icons/country_flags.svg"
          :icon="option.countryCode?.toUpperCase()"
          class="rounded-sm mr-2 country-flag-icon--value"
        />
        <div>{{option.name}}</div>
      </div>
    </template>
  </Dropdown>
</template>